import React, { useMemo, useCallback } from "react";
import styles from "./FileComponent.module.css";

function UploaderImage({
  value,
  url,
  // handleChange,
  // multiple,
  // accept = "image/*",
  error,
  title,
  default_image,
  cirularBanner,
  Banner,
  placeholder,
  Wallpaper,

  ...rest
}) {
  const backgroundStyle = useMemo(
    () => ({
      backgroundImage: `url(${url})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderColor: error ? "red" : "#c2c2c2",
    }),
    [url, error]
  );

  const renderPlusIcon = useCallback(() => {
    if (!value && !default_image) {
      return cirularBanner ? (
        <img
          alt=""
          width="25"
          src={require("../../assets/img/ic_add_image2x.png")}
        />
      ) : (
        <img
          alt=""
          width="25"
          src={require("../../assets/img/ic_add_image2x.png")}
        />
      );
    }
    return null;
  }, [value, default_image, cirularBanner]);

  const renderTextUpload = useCallback(() => {
    if (!value && !default_image && !cirularBanner) {
      return placeholder ? placeholder : "Upload Banner Image";
    }
    return null;
  }, [value, default_image, cirularBanner,placeholder]);
  return (
    <div>
      <div className={styles.imageBtnContainerNew}>
        <div
          className={
            cirularBanner ? styles.imageProfileNew : Banner ? styles.BannerClass :  Wallpaper? styles.WallpaperClass: styles.imagePlusNew  
          }
          style={backgroundStyle}
        >
          {default_image && !value ? <img src={url} crossOrigin="anonymous" className={styles.defaultImageWrar} /> : (
            <>
              <div className={styles.imgLowerContainer}>
                <div>
                  <span className={styles.plus}>{renderPlusIcon()}</span>
                  <div className={styles.textUpload}>{renderTextUpload()}</div>
                </div>
              </div>
            </>
          )}

        </div>
      </div>
      {title && (
        <div className={styles.tooltipFlex}>
          <span className={styles.tipText}>{title}</span>
        </div>
      )}
    </div>
  );
}

export default UploaderImage;
